import React from 'react';
import { ReactComponent as ModalIcon } from '../../images/Icons/quiz.svg';

export default function ModalsHeaderQuiz() {

  return (
    <div>
      <div className="ModalsHeader blue">
        <div>
          <ModalIcon />
        </div>
      </div>
      <div className="ModalsHeaderShadow"></div>
    </div>
  );
}
